module.exports = __webpack_public_path__ + "static/media/img_female_annimation5.a3b38b3c.gif";